// Derives a colour from an entry's position within a set, spreading hues evenly around the
// wheel so neighbouring entries stay distinguishable. For anything that needs a colour per
// item when none has been assigned -- chart series, grouped rows, legends, badges.
export const colorFromIndex = (index: number, total: number) =>
    `hsl(${Math.round((index * 360) / Math.max(total, 1))}, 65%, 45%)`
